import template from './box-input.html';

export default angular.module('gm.wealth.common')
  .directive('gmwBoxInput', gmwBoxInput)
  .name;

function gmwBoxInput() {
  'ngInject';

  const directive = {
    link,
    replace: true,
    require: ['ngModel', '^^form'],
    restrict: 'E',
    scope: {
      blur: '&?',
      change: '&?',
      currency: '@?',
      description: '@?',
      focus: '&?',
      isReadonly: '=?',
      hasError: '=?',
      label: '@?',
      noLabel: '=?',
      max: '=?',
      maxlength: '@?',
      metaText: '@?',
      metaUrl: '@?',
      min: '=?',
      minlength: '@?',
      pattern: '@?',
      placeholder: '@?',
    },
    template,
    transclude: {
      metaLeft: '?gmwBoxInputMetaLeft',
      metaRight: '?gmwBoxInputMetaRight',
      labelRight: '?gmwBoxInputLabelRight',
    },
  };
  return directive;

  function link(scope, _element, attrs, ctrl, transclude) {
    const form = ctrl[1];
    const ngModel = ctrl[0];

    scope.form = form;
    scope.name = attrs.name;
    scope.ngModel = ngModel;
    scope.type = attrs.type || 'text';
    scope.model = {
      value: '',
    };

    scope.isMetaLeft = transclude.isSlotFilled('metaLeft');
    scope.isMetaRight = transclude.isSlotFilled('metaRight');
    scope.hasLabelRight = transclude.isSlotFilled('labelRight');

    scope.onBlur = () => {
      scope.active = false;
      ngModel.$setTouched();

      if (angular.isFunction(scope.blur)) {
        scope.blur();
      }
    };

    scope.onChange = () => {
      if (angular.isFunction(scope.change)) {
        scope.change();
      }
    };

    scope.onFocus = () => {
      if (!scope.isReadonly) {
        scope.active = true;

        if (angular.isFunction(scope.focus)) {
          scope.focus();
        }
      }
    };

    ngModel.$render = () => {
      scope.model.value = ngModel.$viewValue;
    };

    scope.$watch('model.value', (newVal) => {
      ngModel.$setViewValue(newVal);
    });

    attrs.$observe('disabled', (newVal) => {
      scope.disabled = newVal;
    });
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/common/directives/box-input/box-input.js